// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2wMPb","footer":"ModalCreateQualiphyProcedure_footer__2hpq6","additionData":"ModalCreateQualiphyProcedure_additionData__2-vLy"};